export const serverUrl = "https://cautious-fatigues-crab.cyclic.cloud"
